import React from 'react';

import * as Styled from './ButtonSound.styles';

export interface ButtonSoundProps {
  onAction: () => void;
  $isPlaying: boolean;
  $isVisible: boolean;
}

const ButtonSound: React.FC<ButtonSoundProps> = ({ onAction, $isPlaying, $isVisible }) => {
  return (
    <Styled.Wrapper
      onClick={onAction}
      className={$isVisible && $isPlaying ? "show playing" : $isVisible && !$isPlaying ? "show" : ''}
    >
      {$isPlaying ? (        
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.263672 5.99998V12H4.93034L10.7637 17V0.99998L4.93034 5.99998H0.263672ZM8.43034 5.82998V12.17L5.89867 9.99998H2.59701V7.99998H5.89867L8.43034 5.82998ZM16.0137 8.99998C16.0137 7.22998 14.8237 5.70998 13.097 4.96998V13.02C14.8237 12.29 16.0137 10.77 16.0137 8.99998ZM13.097 0.22998V2.28998C16.4687 3.14998 18.9303 5.82998 18.9303 8.99998C18.9303 12.17 16.4687 14.85 13.097 15.71V17.77C17.7753 16.86 21.2637 13.28 21.2637 8.99998C21.2637 4.71998 17.7753 1.13998 13.097 0.22998Z" fill="white"/>
        </svg>        
      ) : (
        <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.88251 0.424194L0.296265 2.06919L5.20126 7.15586L4.87501 7.50586H0.375015V14.5059H4.87501L10.5 20.3392V12.6509L15.2025 17.5275C14.4713 18.0992 13.65 18.5542 12.75 18.8225V21.2259C14.2575 20.8759 15.6413 20.1525 16.8113 19.1842L19.1175 21.5759L20.7038 19.9309L1.88251 0.424194ZM8.25002 14.7042L5.80876 12.1725H2.62501V9.83919H5.80876L6.79877 8.81253L8.25002 10.3175V14.7042ZM18.375 11.0059C18.375 11.9625 18.2063 12.8842 17.9138 13.7359L19.635 15.5209C20.265 14.1559 20.625 12.6275 20.625 11.0059C20.625 6.01253 17.2613 1.83586 12.75 0.774194V3.17753C16.0013 4.18086 18.375 7.30753 18.375 11.0059ZM10.5 1.67253L8.38502 3.86586L10.5 6.05919V1.67253ZM15.5625 11.0059C15.5625 8.94086 14.415 7.16753 12.75 6.30419V8.39253L15.54 11.2859C15.5513 11.1925 15.5625 11.0992 15.5625 11.0059Z" fill="white"/>
        </svg>
        
      )}

    </Styled.Wrapper>
  );
};

export default ButtonSound;
